const rechargeErrors = {
  400: {
    message: "targetMsisdn, rechargeValue and paymentMethod are required",
    handlingMessage: "Aconteceu um erro. Por favor, refaça a recarga.",
  },
};

export default rechargeErrors;
